import axios from 'axios';
import {
  getAccessToken,
  liffGetProfile
} from './auth.service';
import { getCustomerFOA } from './foa.service';

const liff = window.liff;
const AxiosPromotion = axios.create();

AxiosPromotion.interceptors.request.use(async (config) => {
  const perPage = config.perPage || 100;
  const currentPage = config.currentPage || 1;
  config.params = { ...config.params, currentPage, perPage };

  const token = await getAccessToken();
  config.headers.authorization = `Bearer ${token}`;
  const liffProfile = await liffGetProfile();
  const customer = await getCustomerFOA(liffProfile.userId);
  config.headers.account = `${customer?.amwayNumber}`;
  config.headers.customer = `${customer?.partyId}`;
  return config;
});

AxiosPromotion.interceptors.response.use(
  (res) => {
    return res;
  },
  (error) => {
    if (
      (error.response !== undefined && error.response.status === 401) ||
      error.response.status === 403
    ) {
      sessionStorage.removeItem('facadeToken');
      window.location.reload();
    }
    return Promise.reject(error);
  },
);

export default AxiosPromotion;
